/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import { RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
import { appendStyleTag } from '../../extensions/custom-styles';
import StarRatingStyle from './inline-styles';

class edit extends Component {
	componentDidUpdate() {
		const cssStyle = StarRatingStyle( this.props );
		appendStyleTag( this.props, cssStyle );
	}

	componentDidMount() {
		const cssStyle = StarRatingStyle( this.props );
		appendStyleTag( this.props, cssStyle );
	}
	render() {
		const {
			isSelected,
			className,
			attributes,
			setAttributes,
		} = this.props;
		const { textAlignment, prefixContent, titleContent, suffixContent, prefixColor, titleColor, suffixColor, displayPrefix, displaySuffix, prefixTag, titleTag, suffixTag } = attributes;
		const wrapperClasses = classnames(
			className,
			`has-text-align-${ textAlignment }`,
		);
		return <div className={ wrapperClasses }>
			{ isSelected && <Inspector { ...this.props } /> }
			<BaseWrapper { ...this.props }>
				{ displayPrefix && <RichText
					tagName={ prefixTag }
					value={ prefixContent }
					onChange={ ( content ) => setAttributes( { prefixContent: content } ) }
					placeholder={ __( 'Title prefix' ) }
					style={ { textAlign: textAlignment, color: prefixColor } }
					onClick={ () => {
						setAttributes( { selectedTitle: 'prefix' } );
					} }
					className="gutenify-section-title-prefix"
				/> }
				<RichText
					tagName={ titleTag }
					value={ titleContent }
					onChange={ ( content ) => setAttributes( { titleContent: content } ) }
					placeholder={ __( 'Title' ) }
					style={ { textAlign: textAlignment, color: titleColor } }
					onClick={ () => {
						setAttributes( { selectedTitle: 'title' } );
					} }
					className="gutenify-section-title-main"
				/>
				{ displaySuffix && <RichText
					tagName={ suffixTag }
					value={ suffixContent }
					onChange={ ( content ) => setAttributes( { suffixContent: content } ) }
					placeholder={ __( 'Title suffix' ) }
					style={ { textAlign: textAlignment, color: suffixColor } }
					onClick={ () => {
						setAttributes( { selectedTitle: 'suffix' } );
					} }
					className="gutenify-section-title-suffix"
				/> }
			</BaseWrapper>
		</div>;
	}
}

export default edit;
